import type {
  CappedTableResultOfEventLogEntry,
  ListMyEventLogsParams,
  UserLocationHistory
} from './models/api';
import type {
  LoggedUserDetail,
  LoggedUserToEdit,
  PasswordToChange,
  PhoneToChange,
  PowerBiEmbeddedTokenResult,
  SetSignatureResult,
  UserAppearanceToEdit
} from './models/mainservice';
import { protectedApiClient, protectedApiClientV2 } from './support/baseApiClients';
import { getUploadHeaders } from './support/helper';

export default {
  deleteUserDevice: async (deviceId: string) => {
    const result = await protectedApiClient.delete<undefined>(`/LoggedUser/device/${deviceId}`);
    return result.data;
  },
  disableUserDevice: async (deviceId: string) => {
    const result = await protectedApiClient.put<undefined>(
      `/LoggedUser/device/${deviceId}/disable`
    );
    return result.data;
  },
  editUser: async (user: LoggedUserToEdit) => {
    const result = await protectedApiClient.put<LoggedUserDetail>(`/LoggedUser`, user);
    return result.data;
  },
  enableUserDevice: async (deviceId: string) => {
    const result = await protectedApiClient.put<undefined>(`/LoggedUser/device/${deviceId}/enable`);
    return result.data;
  },
  getEventLog: async (params: ListMyEventLogsParams) => {
    const result = await protectedApiClientV2.get<CappedTableResultOfEventLogEntry>(
      `/audit/event-logs/me`,
      { params }
    );
    return result.data;
  },
  getLocationHistoty: async (selectedDay: string) => {
    const result = await protectedApiClientV2.get<UserLocationHistory>(
      `/users/me/locations/${selectedDay}`
    );
    return result.data;
  },
  getAppUserDetail: async () => {
    const result = await protectedApiClient.get<LoggedUserDetail>(`/loggedUser`);
    return result.data;
  },
  changeEmail: async (email: string) => {
    const result = await protectedApiClient.put<undefined>(`/LoggedUser/Email`, { email });
    return result.data;
  },
  changePassword: (password: PasswordToChange) => {
    return protectedApiClient.put<undefined>(`/loggedUser/password`, password);
  },
  setSignature: async (formData: any) => {
    const result = await protectedApiClient.post<SetSignatureResult>(
      `/LoggedUser/SetSignature`,
      formData,
      getUploadHeaders
    );
    return result.data;
  },
  changePhone: async (phoneToChange: PhoneToChange) => {
    const result = await protectedApiClient.put<undefined>(`/LoggedUser/phone`, phoneToChange);
    return result.data;
  },
  getPowerBIConfig: async () => {
    const result = await protectedApiClient.get<PowerBiEmbeddedTokenResult>(
      '/loggedUser/powerbiEmbeddedReport'
    );

    return result.data;
  },
  deleteProfilePicture: async () => {
    const result = await protectedApiClient.delete<undefined>(`/loggedUser/profilePicture`);
    return result.data;
  },
  changeAppearance: async (appearance: UserAppearanceToEdit) => {
    const result = await protectedApiClient.put<undefined>(`/loggedUser/appearance`, appearance);
    return result.data;
  }
};
